export const safeModeLabel = "Q3GSvb";
export const recoveryModeLabel = "CWfUZc";
export const configJsonActiveLabel = "AFoaId";
export const configJsonActiveDetails = "S5u0ec";
export default {safeModeLabel,recoveryModeLabel,configJsonActiveLabel,configJsonActiveDetails};